export default function(params) {
  var self = this;

  self.defaults = {
    style: {}
  };

  self.config = _.extend({}, self.defaults, params);
  self.emitter = new Emitter();
  self.presented = false;

  self.present = function() {
    self.appendFrame();
    self.presented = true;
    self.emitter.emit('presented');
  };

  self.appendFrame = function() {
    self.$frame = $(self.config.frame);
    self.$frame.css(self.config.style);
    self.config.$container.append(self.$frame);
  };

  self.destroy = function() {
    self.$frame.remove();
    self.emitter.emit('destroy');
  };

  self.hide = function() {
    self.$frame.hide();
    self.emitter.emit('hide');
    self.$frame.remove();
  };

  self.show = function() {
    self.$frame.show();

    let frame = self.$frame[0]

    if (typeof frame.contentWindow === 'undefined')
      frame = frame.querySelector('iframe')

    if (typeof frame.contentWindow === 'object' &&
          typeof frame.contentWindow.postMessage === 'function') {
      const prepareResize = { context: 'h5p', action: 'prepareResize' }
      const resize = Object.assign({}, prepareResize, { action: 'resize'})

      frame.contentWindow.postMessage(prepareResize, '*')
      frame.contentWindow.postMessage(resize, '*')
    }

    self.emitter.emit('show');
  };

  return self;
}
